/** OpenStreetMap tiles of the setup flow's Leaflet maps (the pin map and the delivery map). */
export const OSM_TILE_URL =
  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

/** The attribution OSM requires on every map that shows its tiles. */
export const OSM_TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>';
